import Highcharts from "highcharts";
import Highcharts3D from "highcharts/highcharts-3d";
import HighchartsReact from "highcharts-react-official";
import { useInstalledCapicity } from "../../hooks/useInstalledCapicity";
import { useMemo } from "react";
import { useLanguageTranslation } from "../../hooks/useLanguageTranslation";
import { useSelector } from "react-redux";

const DoughnutChart = () => {
  const { languageType } = useSelector((state) => state.homeSlice);
  const { getText } = useLanguageTranslation();
  const { totals, isLoading } = useInstalledCapicity();
  const solar = totals.solar || 0;
  const thermal = totals.thermal || 0;
  const hydro = totals.hydro || 0;
  const total = totals.total || 0;

  const formatPercent = useMemo(() => {
    return (value, totalValue = total) => {
      if (!totalValue) return 0;
      return Number(((value / totalValue) * 100).toFixed(1));
    };
  }, [total]);
  const chartData = useMemo(
    () => [
      {
        label: getText("Solar Power", "सौर ऊर्जा"),
        value: solar,
      },
      {
        label: getText("Thermal Power", "ताप विद्युत"),
        value: thermal,
      },
      {
        label: getText("Hydro Power", "जल विद्युत"),
        value: hydro,
      },
    ],
    [solar, thermal, hydro, languageType],
  );

  const getAccessibleSummary = () => {
    return `
    Total capacity: ${total} MW.
    ${chartData
      .map(
        (item) =>
          `${item.label}: ${item.value} MW (${formatPercent(
            item.value,
            total,
          )}%)`,
      )
      .join(", ")}
  `.trim();
  };

  const data = chartData.map((item) => [
    `${item.label} (${formatPercent(item.value, total)}%)`,
    item.value,
  ]);

  const options = {
    chart: {
      type: "pie",
      height: 400,
      spacingTop: 50,
      options3d: {
        enabled: true,
        alpha: 35,
        beta: 0,
        depth: 100,
        viewDistance: 100,
      },
    },
    title: {
      text: null,
      // text: getText("NEEPCO Power Generation", "नीपको बिजली उत्पादन चार्ट"),
      align: "center",
      marginTop: 16,
      enabled: false,
    },
    plotOptions: {
      pie: {
        innerSize: "40%",
        depth: 45,
        dataLabels: {
          enabled: true,
          format: "{point.name}: {point.y:.1f} MW",
        },
      },
    },
    tooltip: {
      formatter: function () {
        return `
        <b>${this.point.name}</b><br/>
        <b>${this.point.y.toLocaleString()} MW</b><br/>
      `;
      },
      useHTML: true,
    },
    series: [
      {
        data: data,
      },
    ],
  };

  if (isLoading) {
    return <div>Loading...</div>; // Loading state
  }
  return (
    <a className="cursor-none" href="#" onClick={(e) => e.preventDefault()}>
      <details className="sr-only">
        <summary>Power Generation Chart Data Summary</summary>
        <p>
          This doughnut chart shows NEEPCO's power generation capacity by
          source:
        </p>
        <ul>
          <li>{`Total capacity: ${total} MW`}</li>
          <li>{`Solar Power : ${formatPercent(solar)}% ${solar} MW`}</li>
          <li>{`Thermal Power : ${formatPercent(thermal)}% ${thermal} MW`}</li>
          <li>{`Hydro Power : ${formatPercent(hydro)}% ${hydro} MW`}</li>
        </ul>
      </details>
      <div
        className="performance-generation-sec h-100 wow zoomIn pt-2"
        aria-label={`NEEPCO Power Generation breakdown: ${getAccessibleSummary()}`}
      >
        <HighchartsReact highcharts={Highcharts} options={options} />

        <div className="visually-hidden">
          <p>
            Interactive 3D doughnut chart showing power generation capacity by
            source.
          </p>
          {/* <p>
            Hover over segments to see detailed values or view the legend for
            color coding.
          </p> */}
        </div>
      </div>
    </a>
  );
};

export default DoughnutChart;
